var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF4848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7072 9.29289C10.3167 8.90237 9.68354 8.90237 9.29302 9.29289C8.90249 9.68342 8.90249 10.3166 9.29302 10.7071L14.5858 15.9999L9.29289 21.2929C8.90237 21.6834 8.90237 22.3166 9.29289 22.7071C9.68342 23.0976 10.3166 23.0976 10.7071 22.7071L16.0001 17.4142L21.293 22.7071C21.6835 23.0976 22.3167 23.0976 22.7072 22.7071C23.0977 22.3166 23.0977 21.6834 22.7072 21.2929L17.4143 15.9999L22.7071 10.7071C23.0976 10.3166 23.0976 9.68343 22.7071 9.29291C22.3166 8.90238 21.6834 8.90238 21.2929 9.29291L16.0001 14.5857L10.7072 9.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert_error.3f67a209fa8aca9d9cd6dbcb46bb461c.svg";
export { ForwardRef as ReactComponent };